import React from 'react';
import { Switch, Platform } from 'react-native';
import { ADMIN_COLORS } from '../../config/theme/adminColors';

// Switch com as cores do painel admin.
//
// Existe por causa de uma armadilha do react-native-web: ele tem props
// SEPARADAS para o estado ligado (`activeThumbColor` / `activeTrackColor`) e
// ignora `thumbColor` quando o switch está ligado — caindo no default dele,
// `#009688`, um verde-azulado que não existe na nossa paleta. Passar só
// `thumbColor`, como se faz no React Native puro, não tem efeito nenhum com o
// switch ligado.
//
// A BOLA é sempre o mesmo cinza claro — é o que estava fora da paleta. Só a cor
// do trilho ligado é configurável (`accent`), porque telas diferentes usam
// destaques diferentes: o painel usa azul/teal, a tela de produto do aluno usa a
// cor da marca do cliente.
const THUMB = ADMIN_COLORS.surfaceSubtle; // cinza claro
const TRACK_OFF = '#D1D5DB';

const AdminSwitch = ({ value, onValueChange, disabled, accent = ADMIN_COLORS.accent }) => (
  <Switch
    value={value}
    onValueChange={onValueChange}
    disabled={disabled}
    trackColor={{ false: TRACK_OFF, true: accent }}
    thumbColor={THUMB}
    {...(Platform.OS === 'web'
      ? { activeThumbColor: THUMB, activeTrackColor: accent }
      : null)}
  />
);

export default AdminSwitch;
